module.exports = __webpack_public_path__ + "img/img-6c3e65.jpg";